import { Edit, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

export const CountryEdit = () => {
  return (
    <Edit title={<CustomTitle />}>
      <SimpleForm>
        <TextField source="id" />
        <TextInput source="title" />
      </SimpleForm>
    </Edit>
  );
};
